import React from 'react';
import ReactDOM from 'react-dom';
import posthog from 'posthog-js'
import { PostHogProvider} from 'posthog-js/react'

import App from './App';

posthog.init('phc_1fOkoaVrY43AumWl2huvHIfbgtAo6dK2vDWRLLjq1Qp', { api_host: 'https://us.i.posthog.com' })

ReactDOM.render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>
, document.getElementById('root'));